import { Button, Card, Col, Form, Input, InputNumber, Modal, Radio, Row, Select, Switch, Image } from 'antd';
import { useContext, useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import systemConfig from '../../../config/systematic';
import { SocketContext } from '../../../App';
import dayjs from 'dayjs';

export default function DimSumEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    const [dimSumCategoryData, setDimSumCategoryData] = useState<any>();
    const [baseData, setBaseData] = useState<any>();
    const [picData, setPicData] = useState<any>([]);
    const [radioValue, setRadioValue] = useState<any>();
    const [showUpdate, setShowUpdate] = useState<any>(false);

    const [picState, setPicState] = useState<any>(true);

    //选择图片窗口
    const [choosePicVisible, setChoosePicVisible] = useState(false);

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            // form.setFieldsValue({ branchStoreId: localStorage.getItem("currentBranchStoreId") });
            form.setFieldsValue({ branchStoreId: contextData?.currentBranchStoreId });

            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    setBaseData(res.data);
                    await checkDate(res.data.dimSumCategory.dimSumHistory);

                    if (data.type === "EDIT") {
                        form.setFieldsValue({ branchStoreMenuWarehouseId: res.data.branchStoreMenuWarehouseId });
                    }
                }
            })
        }

        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "dimSumCategory",
                apiExtend: 'showList',
                apiData: {
                    dimSumHistoryId: data.sendPageData.dimSumHistoryId,
                }
            }).then(res => {
                if (res.success) {
                    setDimSumCategoryData(res.data);
                }
            })
        }
        fetchData();
    }, [])

    /**
     * 选择图片
     */
    const handlePic = () => {
        fetchApi.GET(wmService, {
            apiId: "branchStoreMenuWarehouse",
            apiExtend: 'showPicList',
            apiData: {
                branchStoreMenuWarehouseId: baseData.branchStoreMenuWarehouseId,
            }
        }).then(res => {
            if (res.success) {
                setPicData(res.data);
            }
        })
        setChoosePicVisible(true);
    };

    const closeModal = () => {
        setChoosePicVisible(false);
    };

    const checkDate = (row: any) => {
        if (dayjs(row.startTime).format("YYYY-MM-DD") <= dayjs().format("YYYY-MM-DD") && dayjs(row.endTime).format("YYYY-MM-DD") >= dayjs().format("YYYY-MM-DD")) {
            setShowUpdate(true);
        }
        // else {
        //     console.log(2);
        // }
    };

    const handleCheckCode = (e: any) => {
        if (e.target.value === "wisca87695598") {
            setPicState(false);
        }
    };

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const onChangeRadio = (e: any) => {
        setRadioValue(e.target.value);
    };

    const handleUpdatePic = () => {
        form.setFieldsValue({ fileDestination: radioValue });
        setChoosePicVisible(false);
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'dimSumDetail',
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '菜式'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="branchStoreMenuWarehouseId"
                                name="branchStoreMenuWarehouseId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="菜式名称"
                                name="foodName">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="扩展名称"
                                name="expandFoodName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="所属分类"
                                name="dimSumCategoryId">
                                <Select
                                    showSearch
                                    placeholder="所属分类"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(dimSumCategoryData, {
                                        itemName: "shopTypeName",
                                        includeNull: false,
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="价格"
                                name="price"
                                rules={[{ required: true, message: '请输入价格!' }]}
                            >
                                <InputNumber min={0} />
                            </Form.Item>
                        </Col>

                        <Col span={showUpdate ? 21 : 24}>
                            <Form.Item
                                label="图片"
                                name="fileDestination"
                            >
                                <Input disabled={picState} />
                            </Form.Item>
                        </Col>

                        <Col span={showUpdate ? 3 : 0}>
                            <Button onClick={handlePic} type="primary" size="small">更新</Button>
                            <Modal
                                title="选择图片："
                                open={choosePicVisible}
                                onOk={handleUpdatePic}
                                onCancel={closeModal}
                                width={800}
                            >
                                <Radio.Group onChange={onChangeRadio}>
                                    <Card title="" bordered={false}>
                                        {
                                            // eslint-disable-next-line array-callback-return
                                            picData.map((item: any) => {
                                                if (item.fileDestination) {
                                                    return (
                                                        <Card.Grid style={{ width: '251px', textAlign: 'center' }}>
                                                            {
                                                                <Radio
                                                                    style={{ alignItems: 'flex-start' }}
                                                                    key={item.id}
                                                                    value={item.fileDestination}
                                                                >
                                                                    <Image
                                                                        width={150}
                                                                        height={150}
                                                                        preview={false}
                                                                        src={item.filesServerUrl + '/' + item.fileDestination}
                                                                    />
                                                                </Radio>
                                                            }
                                                        </Card.Grid>
                                                    )
                                                }
                                            })
                                        }
                                    </Card>
                                </Radio.Group>
                            </Modal>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="验证码"
                                name="checkCode"
                            >
                                <Input onChange={handleCheckCode} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="上架"
                                    unCheckedChildren="下架" />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}